import { call, put, takeEvery } from 'redux-saga/effects';

import * as types from './constants';
import * as actions from './actions';
import * as listActions from '../codesList/actions';
import { handleErrors, fetch } from '../../../api';
import api from '../../../api/endpoints';
import store from '../../../store';

function* activateCode({ payload: { id, type, onSuccess } }) {
  const { getState, dispatch } = store;

  try {
    const { data } = yield call(fetch, { api: api.codes.activate, id });

    dispatch(listActions.getCodesRequest({ type, curr_page: getState().getCodes.curr_page, filters: getState().getCodes.filters }));

    onSuccess && onSuccess();
    yield put(actions.activateCodeDone(data.result));
  } catch (error) {
    yield handleErrors({
      error,
      putErrorData: actions.activateCodeFailed,
      endpoint: api.codes.activate.url
    });
  }
}

export const activateCodeSaga = takeEvery(types.ACTIVATE_CODE_REQUEST, activateCode);